import { SAVE_BEACON, SELECT_BEACON } from '../constants/beacon.constants';

export const selectBeacon = (beacon, callback) => ({ type: SELECT_BEACON, beacon, callback});
export const saveBeacon = (beacon, callback) => ({ type: SAVE_BEACON, beacon, callback});